import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Grid2 as Grid,
  Card,
  CardActionArea,
  alpha,
  Paper,
  Breadcrumbs,
  Stack,
} from '@mui/material';
import {
  ChevronRight,
  MapOutlined,
  LocationOnOutlined,
  AccountBalanceOutlined,
  SegmentOutlined,
  DatasetOutlined,
} from '@mui/icons-material';

const LookupContent = ({ userCategory }) => {
  console.log(userCategory);

  const LookupCard = ({ to, label, color, icon }) => (
    <Grid size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
      <Link to={to} style={{ textDecoration: 'none' }}>
        <Card
          elevation={0}
          sx={{
            width: '100%',
            aspectRatio: '1/1',
            borderRadius: '20px',
            border: '1px solid',
            borderColor: alpha(color, 0.2),
            transition: '0.3s',
            '&:hover': {
              transform: 'translateY(-5px)',
              boxShadow: `0 12px 30px ${alpha(color, 0.15)}`,
              borderColor: color,
            },
          }}
        >
          <CardActionArea
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: alpha(color, 0.04),
              color: color,
              textAlign: 'center',
              p: 2,
            }}
          >
            <Box
              sx={{
                p: 2,
                borderRadius: '12px',
                bgcolor: alpha(color, 0.1),
                display: 'flex',
                mb: 2,
              }}
            >
              {icon}
            </Box>
            <Typography
              variant="body1"
              fontWeight={700}
              sx={{ color: 'text.primary', lineHeight: 1.2 }}
            >
              {label}
            </Typography>
          </CardActionArea>
        </Card>
      </Link>
    </Grid>
  );

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#F4F6F8', minHeight: '100vh' }}>
      {/* HEADER & BREADCRUMBS */}
      <Box sx={{ mb: 4 }}>
        <Breadcrumbs separator={<ChevronRight fontSize="small" />} sx={{ mb: 1 }}>
          <Link to="/settings" style={{ textDecoration: 'none' }}>
            <Typography
              variant="body2"
              sx={{
                color: 'primary.main',
                fontWeight: 600,
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Settings
            </Typography>
          </Link>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
            Lookup Management
          </Typography>
        </Breadcrumbs>

        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              p: 1,
              borderRadius: '10px',
              bgcolor: alpha('#1976d2', 0.1),
              color: 'primary.main',
              display: 'flex',
            }}
          >
            <DatasetOutlined fontSize="small" />
          </Box>
          <Typography variant="h5" fontWeight={700} color="text.primary">
            Lookups
          </Typography>
        </Stack>
      </Box>

      {/* LOOKUP CARDS GRID */}
      <Grid container spacing={3}>
        <LookupCard
          to="/lookup/settings/zone"
          label="Zone Management"
          color="#9c27b0" // Purple
          icon={<MapOutlined fontSize="large" />}
        />

        <LookupCard
          to="/lookup/settings/state"
          label="State Management"
          color="#0c5bab" // Blue
          icon={<LocationOnOutlined fontSize="large" />}
        />

        <LookupCard
          to="/lookup/settings/lga"
          label="Local Government"
          color="#0072c3" // Teal
          icon={<AccountBalanceOutlined fontSize="large" />}
        />

        <LookupCard
          to="/lookup/settings/sector"
          label="Sector Management"
          color="#007d79" // Green
          icon={<SegmentOutlined fontSize="large" />}
        />
      </Grid>
    </Box>
  );
};

export default LookupContent;
